module.exports = __webpack_public_path__ + "static/media/service2.70348398.jpg";